/**
 * @generated SignedSource<<84a5890428aa100666f14fc1bd1baf96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConnectorComponentRefInput = {
  kind?: string | null;
  name?: string | null;
  version?: string | null;
};
export type dataValidationRulesLibraryQuery$variables = {
  connectorComponentRef: ConnectorComponentRefInput;
  owner?: string | null;
};
export type dataValidationRulesLibraryQuery$data = {
  readonly validationRulesLibrary: ReadonlyArray<{
    readonly categories: ReadonlyArray<string> | null;
    readonly checkId: number | null;
    readonly containerId: number | null;
    readonly datastoreId: number | null;
    readonly description: string;
    readonly displayName: string;
    readonly provider: string | null;
    readonly resourceName: string;
    readonly ruleLibraryItemRef: {
      readonly rliType: string | null;
    } | null;
    readonly status: string | null;
    readonly statusMessage: string | null;
    readonly tableRef: string | null;
  }> | null;
};
export type dataValidationRulesLibraryQuery = {
  response: dataValidationRulesLibraryQuery$data;
  variables: dataValidationRulesLibraryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connectorComponentRef"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "connectorComponentRef",
        "variableName": "connectorComponentRef"
      },
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "ValidationRuleSummary",
    "kind": "LinkedField",
    "name": "validationRulesLibrary",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resourceName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categories",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "datastoreId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checkId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tableRef",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RuleLibraryItemRef",
        "kind": "LinkedField",
        "name": "ruleLibraryItemRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rliType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataValidationRulesLibraryQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataValidationRulesLibraryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "284005c963c178b6bf35d407ef5a930c",
    "id": null,
    "metadata": {},
    "name": "dataValidationRulesLibraryQuery",
    "operationKind": "query",
    "text": "query dataValidationRulesLibraryQuery(\n  $owner: String\n  $connectorComponentRef: ConnectorComponentRefInput!\n) {\n  validationRulesLibrary(owner: $owner, connectorComponentRef: $connectorComponentRef) {\n    resourceName\n    displayName\n    provider\n    description\n    categories\n    datastoreId\n    status\n    statusMessage\n    containerId\n    checkId\n    tableRef\n    ruleLibraryItemRef {\n      rliType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c6511e958d3a699939fa48719fec104";

export default node;
